import React from "react";
import { Box, Container, TextField, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({}));

function Footer() {
	return (
		<div className="App">
			<Container
				maxWidth="xl"
				style={{
					paddingLeft: 0,
					paddingRight: 0,
					backgroundColor: "#fff",
				}}
			>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					width={1}
					m={2}
				>
					<Box
						fontWeight="fontWeightBold"
						fontFamily="Monospace"
						fontSize={20}
						width={1}
						textAlign="center"
					>
						Created by 💻 :
					</Box>
					<a href="http://nikhiljugale007.netlify.app/" target="_blank">
						<Box
							fontFamily="Monospace"
							fontSize={16}
							m={1}
							width={1}
							textAlign="center"
						>
							nikhiljugale007
						</Box>
					</a>
				</Box>
			</Container>
		</div>
	);
}

export default Footer;
